import moment from 'moment';

export function dateFormatter({ date, t }) {
  return date
    ? moment(date.toDate()).format('DD/MM/YYYY H:mm')
    : t('never')
}
